/**
 * Created by asiulik on 04.04.2018.
 */

import {getRelativePositionToParent} from "../helpers";

define(['jquery', 'tooltip'], function($, Tooltip){

    function Tooltips(){}

    Tooltips.config = {
        tooltipSelector: "[data-tooltip]",
        tooltipContentAttr: "data-tooltip",
        tooltipContentSelector: "[data-tooltip-content]"};

    Tooltips.tooltips = null;

    Tooltips.prototype.init = function(){

        var _this = this;

        const config = Tooltips.config;
        const tooltips = $(config.tooltipSelector);

        if(!tooltips.length) return;

        const tooltipsInstance = tooltips.map(function(index, tooltipElement){

            var $tooltipElement = $(tooltipElement);

            return {
                $tooltipElement: $tooltipElement,
                id: $tooltipElement.attr('id'),
                instance: _this.createTooltipInstance($tooltipElement)
            }

        });

        Tooltips.tooltips = tooltipsInstance;
        return tooltipsInstance;

    };

    Tooltips.prototype.reinit = function(){
        Array.from(Tooltips.tooltips).forEach(_tooltips => {
            if (_tooltips.instance) {
                _tooltips.instance.dispose();
            }

            const identifier = _tooltips.$tooltipElement.attr('id');
            const tooltipElement = document.getElementById(identifier);
            if (tooltipElement) {
                // hacky solution to update the tooltip elements.
                // For some reason the jquery part always get the not updated element
                Array.from(tooltipElement.attributes).forEach(_attribute => {
                    if (_attribute.name.startsWith('data')) {
                        const name = _attribute.name.replace('data-', '');
                        _tooltips.$tooltipElement.data(name, _attribute.value);
                    } else {
                        _tooltips.$tooltipElement.attr(_attribute.name, _attribute.value);
                    }
                });
            }
        })

        this.init();
    };

    Tooltips.prototype.createTooltipInstance = function($tooltipElement){

        if ( $tooltipElement.data('tooltipBlock') )
            return;

        var domElement = createDOMElement(
            $tooltipElement.data('tooltipContent')
        );

        var action = !$tooltipElement.data('tooltipAction') ? $tooltipElement.data('tooltipAction') : 'hover';
        var placement = !!$tooltipElement.data('tooltipPlacement') ? $tooltipElement.data('tooltipPlacement') : 'top';
        var delay = !!$tooltipElement.data('tooltipDelay') ? $tooltipElement.data('tooltipDelay') : 500;
        var offset = !!$tooltipElement.data('tooltipOffset') ? $tooltipElement.data('tooltipOffset') : 0;

        return new Tooltip($tooltipElement.get(0), {
            html: true,
            title: domElement.html(),
            trigger: action,
            placement: placement,
            delay: { show: delay },
            offset: offset,
        }, {
            onCreate: function (options) {
                // console.log('tooltip instance on create', options)
            },
            onUpdate: function (options) {
                // console.log('tooltip instance on update', options)
            }
        })
    };

    function createDOMElement(htmlString){
        return $('<div class="tooltip__content">').html(htmlString);
    }

    return Tooltips;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/tooltip.js